import { useState } from "react";

export const WOMA_SERVICES = [
  { key: "delivery", title: "Livraison", img: "/icons/services/svc-livraison.webp", route: "/orders/new" },
  { key: "taxi", title: "Taxi", img: "/icons/services/svc-taxi.webp", route: "/taxi" },
  { key: "food", title: "Food", img: "/icons/services/svc-food.webp", route: "/food" },
  { key: "shop", title: "Boutiques", img: "/icons/services/svc-boutique.webp", route: "/products?category=commerce" },
  { key: "artisan", title: "ARTISANS", img: "/icons/services/svc-artisan.webp", route: "/artisans" },
  { key: "cargo", title: "Cargo", img: "/icons/services/svc-cargo.webp", route: "/cargo" },
];

// Petit rebond de l'image au toucher, puis l'action (navigation) une fois le rebond joué
export const useTapBounce = (delay = 260) => {
  const [bouncing, setBouncing] = useState(null);
  const tap = (key, action) => {
    if (bouncing) return;
    setBouncing(key);
    setTimeout(() => {
      setBouncing(null);
      action();
    }, delay);
  };
  return { bouncing, tap };
};

export const ServiceImg = ({ service, bouncing, className = "w-16 h-14", testId }) => (
  <img
    src={service.img}
    alt={service.title}
    loading="lazy"
    draggable={false}
    className={`${className} object-contain drop-shadow-md ${bouncing ? "woma-tap-bounce" : ""}`}
    data-testid={testId}
  />
);
